import { render } from "./Glossary.vue?vue&type=template&id=0ad89c62&scoped=true"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"

import "./Glossary.vue?vue&type=style&index=0&id=0ad89c62&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad89c62"]])

export default __exports__